import React, { Component } from 'react'
import { Row, Container, Modal, Button, Alert, Col } from 'react-bootstrap';
export class modalImpresion extends Component {
    handleClose=()=>{
        const {hideModalImp} = this.props;
        hideModalImp();
    }
    render() {
        const show = this.props.showPress;
        const {impresionPDF} = this.props
        const {enviarCorreo} = this.props
        const {mensaje} = this.props;
        const handleClose = this.handleClose
        return (
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Documento Finalizado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        { (mensaje && mensaje!=="") &&    <Alert variant='success'>
                                {mensaje}
                        </Alert>}
                        <Row className="justify-content-md-center" >
                            <Col>
                                <Button onClick={enviarCorreo} className="buttonImp" variant="outline-primary" size="lg" block >
                                    <img className="btnimg" src="/enviar_pdf.png" alt="" />
                                    Enviar Correo
                                </Button>
                            </Col>
                        </Row>

                        <Row className="justify-content-md-center" >
                            <Col>
                                <Button onClick={impresionPDF} className="buttonImp" variant="outline-info" size="lg" block >
                                    <img className="btnimg" src="/imprimir_pdf.png" alt="" />
                                    Imprimir Documento
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        )
    }
}

export default modalImpresion
